import * as React from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/taskpane/components/ui/dialog";
import { Button } from "@/taskpane/components/ui/button";
import { useSubscription } from "@/hooks/useSubscription";
import { useLogout } from "@/hooks/useLogout";

interface UpgradePlanDialogProps extends React.ComponentPropsWithoutRef<typeof Dialog> { }

const UpgradePlanDialog = ({ ...props }: UpgradePlanDialogProps) => {
  const dialogContentRef = React.useRef<HTMLDivElement>(null);
  const logoutMutation = useLogout();

  useSubscription({
    staleTime: 30000, // 30 seconds
  });

  const handleSwitchAccount = async () => {
    await logoutMutation.mutateAsync();
  };

  return (
    <Dialog {...props}>
      <DialogContent showCloseButton={false} ref={dialogContentRef}>
        <DialogHeader>
          <img
            src="../../assets/aila-logo-updated.png"
            alt="Logo"
            className="w-[130px] h-auto mb-4 mx-auto"
          />
          <DialogTitle>Upgrade Your Plan</DialogTitle>
          <DialogDescription className="text-neutral-400">
            It looks like you don't have licence to use AILA MS Word addin. Please buy a licence to
            continue.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex-col sm:flex-col gap-2">
          <Button onClick={() => window.open(`${process.env.APP_FRONTEND_URL}/pricing`, "_blank")} className="w-full">
            Buy Licence
          </Button>
          <Button
            variant="outline"
            onClick={handleSwitchAccount}
            className="w-full"
            disabled={logoutMutation.isPending}
          >
            {logoutMutation.isPending ? "Switching Account..." : "Switch Account"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default UpgradePlanDialog;
